import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button.tsx";
import { CircleHelp, Crown } from "lucide-react";
import { Checkbox } from "../ui/checkbox";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  disabled?: boolean;
  isHdOptionEnabled?: boolean;
  hdOptionSelected?: boolean;
  onHdOptionChange?: (checked: boolean | string) => void;
  setShowDialog: (showDialog: boolean) => void;
}

const HdOption: React.FC<Props> = ({
    disabled = false,
    isHdOptionEnabled,
    hdOptionSelected = true,
    onHdOptionChange,
    setShowDialog,
  }) => {
  const { t } = useTranslation();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowDialog(true);
  };
  return (
    <>
      {!isHdOptionEnabled ? (
        <div className="flex flex-col gap-2 rounded-b-lg bg-hdOption-bg -mt-5 pb-4">
          <div className="flex flex-col items-center gap-2">
            <div className="flex justify-center">
              <div className="w-16 h-8 mt-6 rounded-xl flex items-center justify-center">
                <Crown className="w-6 h-6 text-hdOption-icon" />
              </div>
            </div>
            <h5 className="flex flex-col font-medium text-sm leading-[18px] text-center max-w-[347px]">
              <div dangerouslySetInnerHTML={{ 
                __html: `${t("HdNotsubscribedInformation1")} <strong>${t("HdNotsubscribedInformation2")}</strong> ${t("HdNotsubscribedInformation3")}` 
              }} />
            </h5>
            <Button onClick={handleClick} variant="outline">
              {t("ChooseHDOption")}
            </Button>
          </div>
        </div>
      ) : (
        <div className={`flex justify-center flex-col gap-2 rounded-b-lg -mt-6 pb-4 ${disabled ? "bg-[#F9FAFB]" : "bg-hdOption-bg"}`}>
          <div className="flex justify-center items-center gap-2 mt-8">
            <div className="flex justify-center items-center">
              <Checkbox
                disabled={disabled}
                checked={hdOptionSelected}
                onCheckedChange={(checked) => onHdOptionChange?.(checked)}
                className="w-4 h-4 text-amber-600 bg-gray-100 border-gray-300 rounded focus:ring-amber-500 focus:ring-2"
              />
            </div>
            <h5 className={`font-medium text-sm leading-6 ${disabled ? "text-gray-400" : "text-black"}`}>
              {t("keepHDVersion")}
            </h5>
            {!disabled && 
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger className="bg-transparent" onClick={(e) => e.preventDefault()}>
                    <CircleHelp className="w-4 h-4" />
                  </TooltipTrigger>
                  <TooltipContent side="bottom" className="max-w-[200px] text-center text-[#6F6C90]">
                    <p>{t("keepHDVersionTooltip")}</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            }
            <div className="text-amber-600 rounded-xl flex items-center justify-center">
              <Crown className={`w-5 h-5 ${disabled ? "text-[#9AA8BC]" : "text-hdOption-icon"}`} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HdOption;
